import React from "react";

type Props = {
  onRestartAll: () => void;
  onHome: () => void;
  onOpenShop: () => void;
};

export function Toolbar({ onRestartAll, onHome, onOpenShop }: Props) {
  return (
    <div className="app-toolbar">
      <button className="toolbar-btn" onClick={onRestartAll} aria-label="Restart from level 1">
        ↺ Restart
      </button>

      <button className="toolbar-btn toolbar-btn--primary" onClick={onHome} aria-label="Home">
        ⌂ Home
      </button>

      <button className="toolbar-btn" onClick={onOpenShop} aria-label="Open Shop">
        🛒 Shop
      </button>
    </div>
  );
}
